import React from "react";

const InputField = ({ title, type, label, value, onChange, required=false }) => {
  return (
    <div className="relative block w-full mt-10 text-left border-inherit">
      <label
        className="text-sm block pointer-events-none text-black/60 border-inherit"
        htmlFor={label}
      >
        {title}
      </label>
      <input
        className="flex-grow text-left appearance-none bg-transparent text-black overflow-hidden pt-[5px] pb-[10px]
        w-full box-border  border-b border-b-black/60 border-solid outline-none"
        type={type}
        id={label}
        value={value}
        onChange={onChange}
        required={required}
      />
    </div>
  );
};

export default InputField;
